import { render } from "./OrderCart.vue?vue&type=template&id=c810babc"
import script from "./OrderCart.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCart.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderCart/OrderCart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c810babc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c810babc', __exports__)) {
    console.log('reload')
    api.reload('c810babc', __exports__)
  }
  
  module.hot.accept("./OrderCart.vue?vue&type=template&id=c810babc", () => {
    console.log('re-render')
    api.rerender('c810babc', render)
  })

}


export default __exports__